import { SmallIcon, Tag, TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { LOCATION_TYPES } from '../store/models/Shift'

interface Props {
  hasLocationIssueAndGeofencing: boolean
  outOfRadiusIssue: boolean
  locationType: string | null | undefined
  workplaceName: string | undefined
  hasGeolocation: boolean
  hasGeofencing: boolean
  hasLocation: boolean
  hasShiftLocations: boolean
}

export const shiftLocationTagAttributes = ({
  hasLocationIssueAndGeofencing,
  outOfRadiusIssue,
  locationType,
  workplaceName,
  hasGeolocation,
  hasGeofencing,
  hasLocation,
  hasShiftLocations,
}: Props): {
  textLabel: string
  tagColor: TagColor
  icon: SmallIcon
} => {
  const { champagne, grey } = Tag.Types
  const { BUSINESS_TRIP, OFFICE, WORK_FROM_HOME } = LOCATION_TYPES

  // default values
  const tagColor = grey
  let icon: SmallIcon = 'pin'
  let textLabel = ''

  // alert me if location away from workplace
  if (hasLocationIssueAndGeofencing) {
    return {
      tagColor: champagne,
      icon: 'alert-circle',
      textLabel: outOfRadiusIssue
        ? i18n.t(`clock_in.locations.tooltip.title_out_radius`)
        : i18n.t(`clock_in.locations.tooltip.title_unknown_radius`),
    }
  }

  // show me if location within radius from workplace
  if (hasGeofencing && hasShiftLocations) {
    return {
      tagColor,
      icon,
      textLabel: i18n.t('time_tracking.table.body.within_radius'),
    }
  }

  // show me geolocation on a map with a "View location" placeholder
  if (hasGeolocation && hasShiftLocations && !hasLocation) {
    return {
      tagColor,
      icon,
      textLabel: i18n.t('clock_in.locations.tooltip.view_location_button'),
    }
  }

  // show me geolocation on a map with the location type
  if (hasGeolocation && hasShiftLocations) {
    switch (locationType) {
      case WORK_FROM_HOME:
        textLabel = i18n.t('clock_in.locations.tags.home')
        break
      case OFFICE:
        textLabel = workplaceName ?? i18n.t('clock_in.locations.tags.office')
        break
      case BUSINESS_TRIP:
        textLabel = i18n.t('clock_in.locations.tags.business_trip')
        break
    }

    return { icon, tagColor, textLabel }
  }

  // show me workplace location
  if (hasLocation) {
    switch (locationType) {
      case WORK_FROM_HOME:
        icon = 'home'
        textLabel = i18n.t('clock_in.locations.tags.home')
        break
      case OFFICE:
        icon = 'office'
        textLabel = workplaceName ?? i18n.t('clock_in.locations.tags.office')
        break
      case BUSINESS_TRIP:
        icon = 'briefcase'
        textLabel = i18n.t('clock_in.locations.tags.business_trip')
        break
    }

    return { icon, tagColor, textLabel }
  }

  return { tagColor, icon, textLabel }
}
